module.exports = __webpack_public_path__ + "static/media/wagaan_head.fd84bc36.png";